/**
 * Utilidades para venta a granel en carta (precio por unidad de medida).
 */

export const BULK_MEASUREMENT_UNITS = [
  { value: 'kg', label: 'Kilogramo (kg)', family: 'mass', factorToBase: 1 },
  { value: 'g', label: 'Gramo (g)', family: 'mass', factorToBase: 0.001 },
  { value: 'l', label: 'Litro (l)', family: 'volume', factorToBase: 1 },
  { value: 'ml', label: 'Mililitro (ml)', family: 'volume', factorToBase: 0.001 },
  { value: 'm', label: 'Metro (m)', family: 'length', factorToBase: 1 },
];

export const normalizeMeasurementUnit = (unit) => (unit || '').trim().toLowerCase();

export const getUnitDefinition = (unit) => {
  const normalized = normalizeMeasurementUnit(unit);
  const found = BULK_MEASUREMENT_UNITS.find((u) => u.value === normalized);
  if (found) return found;
  return { value: normalized, label: normalized, family: 'unit', factorToBase: 1 };
};

/** Unidades que el cliente puede elegir al cargar cantidad (misma familia que la del producto). */
export const getInputUnitsForProduct = (productUnit) => {
  const base = getUnitDefinition(productUnit);
  const sameFamily = BULK_MEASUREMENT_UNITS.filter((u) => u.family === base.family);
  if (sameFamily.length > 0) return sameFamily;
  return [base];
};

export const convertToProductUnit = (quantity, fromUnit, productUnit) => {
  const from = getUnitDefinition(fromUnit);
  const to = getUnitDefinition(productUnit);
  if (from.family !== to.family) {
    return Number(quantity);
  }
  const quantityInBase = Number(quantity) * from.factorToBase;
  return Number((quantityInBase / to.factorToBase).toFixed(6));
};

export const calculateBulkSubtotal = (unitPrice, quantityInProductUnit) => {
  const price = Number(unitPrice);
  const qty = Number(quantityInProductUnit);
  if (!price || !qty || qty <= 0) return 0;
  return Number((price * qty).toFixed(2));
};

export const calculateQuantityFromAmount = (unitPrice, amount) => {
  const price = Number(unitPrice);
  const total = Number(amount);
  if (!price || price <= 0 || !total || total <= 0) return 0;
  return Number((total / price).toFixed(3));
};

export const formatBulkQuantity = (quantity, unit) => {
  if (quantity == null || Number.isNaN(Number(quantity))) return '';
  const formatted = new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  }).format(Number(quantity));
  const u = normalizeMeasurementUnit(unit);
  return u ? `${formatted} ${u}` : formatted;
};

export const formatPricePerUnit = (price, unit) => {
  const u = normalizeMeasurementUnit(unit);
  if (!u) {
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(Number(price));
  }
  return `$${Number(price).toFixed(2)}/${u}`;
};

export const createCartLineId = () =>
  `bulk-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

/** true si el producto del catálogo es venta a granel (tolerante a tipos del JSON). */
export const isBulkCatalogProduct = (product) =>
  Boolean(product && (product.bulkSale === true || product.bulkSale === 'true'));
